import styled from 'styled-components';

import { customScrollMinimal } from '~/components/custom-scroll/CustomScroll.styles';
import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

export const MarkdownA = styled.a`
  ${typographyV2.uiXs}
  color: var(--text-soft);
`;

export const MarkdownTableContainer = styled.div`
  overflow: scroll;
  margin: 1em 0px;
  ${customScrollMinimal}
`;

export const MarkdownTable = styled.table`
  border-spacing: 1px;
  width: 100%;

  tr {
    background-color: var(--background-default);
  }

  td {
    border-bottom: 1px solid var(--border-soft);
  }

  tbody tr:hover {
    background-color: var(--surface-hover);
  }
`;
